module.exports = __webpack_public_path__ + "static/media/Tungsten-Semibold.d8e855e3.otf";